export const ChargingStation = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 27H21" stroke="currentColor" stroke-width="2"/>
<path d="M18 27V5H5V27" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M18 16H23V25C23 26.3807 24.1193 27.5 25.5 27.5V27.5C26.8807 27.5 28 26.3807 28 25V4" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M27 7V13" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M12 11L9 16H14.5L11 21" stroke="currentColor" stroke-width="2"/>
<path d="M29 7V13" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
</svg>`;
